export default "__VITE_ASSET___9ZS0g_O__"